import { Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "../../components/Buttons";
import { useStore } from "../../utils/context";
import { useNavigate } from "react-router-dom";
import useToaster from "../../components/alert";
import "../../utils/tailwind.css";
import Const from "../../utils/constant";
import { useState } from "react";
import Label from "../../components/label";
import { userLogin } from "../../api/user";
import { useMutation } from "@tanstack/react-query";
import GyaankoolLogo from "../../assets/images/gyaankoollogo.png";

const LoginPage = () => {
  const { handleLogin, setUser } = useStore();
  const navigate = useNavigate();
  const toaster = useToaster();
  const [error] = useState(null);

  const loginQuery = useMutation({ mutationFn: userLogin });

  const validationSchema = Yup.object({
    email: Yup.string().required("This field is required."),
    password: Yup.string().required("This field is required."),
  });

  const handleSubmit = async (values) => {
    try {
      const payload = {
        email: values.email,
        password: values.password,
        role: Const.USER_ROLES.ADMIN
      };
      loginQuery.mutate(payload, {
        onSuccess: (res) => {
          handleLogin(res.data);
          navigate("/dashboard");
          setUser({});
          toaster.success(Const.MESSAGES.SUCCESS, "Logged in successfully.");
        },
        onError: () => {
          toaster.error(Const.MESSAGES.FAILED, Const.MESSAGES.INVALID_CREDS);
        }
      });
    } catch (err) {
      toaster.error(Const.MESSAGES.FAILED, Const.MESSAGES.INTERNAL_SERVER_ERROR);
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen bg-[#F9F1FE]">
      <div className="flex shadow-lg">

        <div className="bg-[white] p-8 max-w-full w-[650px]" alt="Img">
          <img src={GyaankoolLogo} alt="logo" className="mx-auto mb-4" width="110px" height="110px" />
          <Label className="text-black font-semibold mb-1 text-[23px]" label="Admin Panel | Gyaankool" />
          <Label className="text-black font-semibold mb-4" label="Login to continue" />
          <Formik initialValues={{ email: "", password: "" }} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ handleChange, handleBlur, handleSubmit, values, errors, touched }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className="font-semibold">
                    Email <sup className="text-red-500">*</sup>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.email && errors.email}
                    placeholder="Enter Email Id"
                    className="!bg-[#F9F1FE] !w-full !border-gray-300 !py-3 !px-4 rounded-md"
                  />
                  <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className="mt-6 mb-10">
                  <Form.Label className="font-semibold">
                    Password <sup className="text-red-500">*</sup>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.password && errors.password}
                    placeholder="Enter your password"
                    className="!bg-[#F9F1FE] !w-full !border-gray-300 !py-3 !px-4 rounded-md"
                  />
                  <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                </Form.Group>

                {error && <div className="mt-3 text-red-500 text-sm">{error}</div>}

                <Button type="submit" className="w-full !border-none  text-black rounded-md transition !bg-[#FCBB32] " >
                  Login
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
